import { optionLabelZh } from "@hisense/shared";
import { useSettings } from "@/api/hooks";

/**
 * Tên tiếng Hoa của loại sản phẩm, đọc từ Cài đặt (`optionLabelsZh.productTypes`). `null` khi admin chưa nhập — chỗ hiển
 * thị khi đó chỉ còn một dòng tiếng Anh như trước. `GET /settings` mọi người đăng nhập đều đọc được (01/10/2026).
 */
export function useProductTypeZh(): (type: string | null | undefined) => string | null {
  const { data: settings } = useSettings();
  const labels = settings?.businessOperations.optionLabelsZh;
  return (type) => optionLabelZh(labels, "productTypes", type);
}
